import { RootState } from 'redux/reducers/rootReducer';

const partnerCreatedAtSelector = (state: RootState) =>
  state.partner.partnerCreatedAt;

export { partnerCreatedAtSelector };
